<template>
  <div>
    <div
      class="text-h3 font-medium "
      :class="$store.state.mobile ? '' : 'mt-4 mb-4 d-flex align-center'"
    >
      <template v-if="$store.getters.languageGetter === '1'">
        طلباتي
      </template>
      <template v-else>
        My Orders
      </template>
      <v-spacer />
      <v-btn-toggle
        v-model="toggleIndex"
        mandatory
        dense
        :class="$store.state.mobile ? 'flex-wrap mb-4' : ''"
      >
        <v-btn
          outlined
          tile
          class="text-capitalize px-8"
          style="margin-right:-1px"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            الجميع
          </template>
          <template v-else>
            All
          </template>
        </v-btn>
        <v-badge
          :value="orderList.unpayed.data.totalItem !== '0'"
          :content="orderList.unpayed.data.totalItem"
          color="#f16056"
          bordered
          overlap
          style="z-index:2"
        >
          <v-btn
            outlined
            tile
            class="text-capitalize"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              انتظار الدفع
            </template>
            <template v-else>
              Awaiting Payment
            </template>
          </v-btn>
        </v-badge>
        <v-badge
          :value="orderList.shipped.data.totalItem !== '0'"
          :content="orderList.shipped.data.totalItem"
          color="#f16056"
          bordered
          style="z-index:1;margin-left: -1px"
        >
          <v-btn
            outlined
            tile
            class="text-capitalize"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              تم شحن الشحنة
            </template>
            <template v-else>
              Shipment Shipped
            </template>
          </v-btn>
        </v-badge>
        <v-btn
          outlined
          tile
          class="text-capitalize"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            ألغيت
          </template>
          <template v-else>
            Canceled
          </template>
        </v-btn>
        <v-btn
          outlined
          tile
          class="text-capitalize"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            مكتمل
          </template>
          <template v-else>
            Completed
          </template>
        </v-btn>
      </v-btn-toggle>
    </div>
    <template v-if="$store.state.mobile">
      <v-row
        v-for="item in target.items"
        :key="item.id"
        class="d-block"
      >
        <div class="sepration" />
        <v-card
          elevation="0"
          outlined
          tile
        >
          <v-card-title class="d-block pe-2 py-2">
            <router-link
              class="d-flex align-center"
              :to="{name: 'UserOrderDetail', params: {id: item.id}}"
            >
              <template v-if="$store.getters.languageGetter === '1'">
                رقم الطلب
              </template>
              <template v-else>
                Order No.
              </template>{{ item.orderNo }}
              <v-spacer />
              <span :class="item.dStatus === '1' ? 'error--text text--darken-1' : 'grey--text'">
                {{ item.dStatus | statusFilter($store.getters.languageGetter) }}
              </span>
              <v-icon
                size="20"
                color="grey"
              >
                mdi-chevron-right
              </v-icon>
            </router-link>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <div
              v-for="(detail,i) in item.detail.slice(0,4)"
              :key="detail.goodDetailId"
            >
              <div class="d-flex ">
                <div class="pe-2">
                  <router-link :to="{name: 'GoodsDetail', params: {id: detail.goodId}}">
                    <v-img
                      :src="detail.specImage ? detail.specImage + '?x-oss-process=image/resize,m_mfit,w_200,h_200' : detail.image + '?x-oss-process=image/resize,m_mfit,w_200,h_200'"
                      width="80"
                      height="80"
                      class="grey lighten-5"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey"
                          />
                        </v-row>
                      </template>
                    </v-img>
                  </router-link>
                </div>
                <div>
                  <div class="mb-2 text-wrap">
                    {{ $store.getters.languageGetter === '1' ? detail.goodName : detail.goodNameEn }}
                  </div>
                  <div class="grey--text body-2">
                    {{ $store.getters.languageGetter === '1' ? detail.goodDetailName : detail.goodDetailNameEn }}
                  </div>
                </div>
                <div class="text-right ps-4 ms-auto">
                  <div class="mb-2 error--text">
                    {{ item.currency }}{{ detail.price }}
                  </div>
                  <div class="grey--text">
                    x{{ detail.buNumber }}
                  </div>
                </div>
              </div>
              <v-divider
                v-if="i < item.detail.length - 1"
                class="my-2"
              />
            </div>
          </v-card-text>
          <v-divider />
          <v-card-actions class="px-4">
            <v-spacer />
            <span class="me-4">{{ item.detail.length }} <template v-if="$store.getters.languageGetter === '1'">
              العناصر
            </template>
              <template v-else>
                items
              </template></span>
            <span class="grey--text text--darken-1 me-1"><template v-if="$store.getters.languageGetter === '1'">
                                                           كمية:
                                                         </template>
              <template v-else>
                Amount:
              </template></span> {{ item.currency }}{{ item.amount }}
          </v-card-actions>
        </v-card>
      </v-row>
      <v-row class="d-block">
        <div class="sepration" />
      </v-row>
    </template>
    <template v-else>
      <div
        v-if="loading"
        class="text-center"
      >
        <v-card
          outlined
          tile
        >
          <v-skeleton-loader
            type="table-thead"
          />
          <div class="px-4">
            <v-skeleton-loader
              type="table-tbody"
            />
          </div>
        </v-card>
      </div>
      <div v-else>
        <v-data-table
          :headers="headers"
          :items="target.items"
          no-data-text="Nothing here"
          loading-text="Loading..."
          hide-default-footer
          class="table-collapse table-bordered"
        >
          <template v-slot:body="{ items }">
            <tbody v-if="!target.items.length">
              <tr>
                <td
                  colspan="4"
                  class="text-center grey--text"
                  style="vertical-align:middle"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    لا شيء هنا
                  </template>
                  <template v-else>
                    Nothing here
                  </template>
                </td>
              </tr>
            </tbody>
            <tbody
              v-for="item in items"
              :key="item.id"
            >
              <tr>
                <td
                  colspan="4"
                  class="pb-0 pt-3"
                  style="height:36px;"
                >
                  <span class="grey--text">{{ item.createTime.substr(0,10) }}<span class="ms-4"><template v-if="$store.getters.languageGetter === '1'">
                                                                                                  رقم الطلب
                                                                                                </template>
                    <template v-else>
                      Order No.
                    </template> </span></span>{{ item.orderNo }}
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    v-for="(detail,i) in item.detail.slice(0,4)"
                    :key="detail.goodDetailId"
                  >
                    <div class="d-flex">
                      <div class="pe-2">
                        <router-link :to="{name: 'GoodsDetail', params: {id: detail.goodId}}">
                          <v-img
                            :src="detail.specImage ? detail.specImage + '?x-oss-process=image/resize,m_mfit,w_200,h_200' : detail.image + '?x-oss-process=image/resize,m_mfit,w_200,h_200'"
                            width="80"
                            height="80"
                            class="grey lighten-5"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey"
                                />
                              </v-row>
                            </template>
                          </v-img>
                        </router-link>
                      </div>
                      <div>
                        <div class="mb-2 text-wrap">
                          {{ $store.getters.languageGetter === '1' ? detail.goodName : detail.goodNameEn }}
                        </div>
                        <div class="grey--text body-2">
                          {{ $store.getters.languageGetter === '1' ? detail.goodDetailName : detail.goodDetailNameEn }}
                        </div>
                      </div>
                      <div class="text-right ps-4 ms-auto">
                        <div class="mb-2 error--text">
                          {{ item.currency }}{{ detail.price }}
                        </div>
                        <div class="grey--text">
                          x{{ detail.buNumber }}
                        </div>
                      </div>
                    </div>
                    <v-divider
                      v-if="i < item.detail.length - 1"
                      class="my-2"
                    />
                  </div>
                </td>
                <td
                  class="error--text text-center"
                >
                  {{ item.currency }}{{ item.actualAmount }}
                </td>
                <td
                  class="text-center"
                >
                  {{ item.dStatus | statusFilter($store.getters.languageGetter) }}
                </td>
                <td
                  class="text-center"
                >
                  <v-btn
                    v-if="item.dStatus === '1' && item.payType !== '2'"
                    color="error"
                    depressed
                    dark
                    block
                    small
                    class="mb-2 text-capitalize"
                    :to="{name: 'UserOrderDetail', params: {id: item.id}}"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      ادفع الآن
                    </template>
                    <template v-else>
                      Pay Now
                    </template>
                  </v-btn>
                  <v-menu
                    :disabled="item.dStatus !== '1'"
                    open-on-hover
                    bottom
                    offset-y
                    right
                    transition="scroll-y-reverse-transition"
                  >
                    <template v-slot:activator="{ on, attrs, value }">
                      <v-btn
                        :to="{name: 'UserOrderDetail', params: {id: item.id}}"
                        depressed
                        block
                        text
                        small
                        outlined
                        class="text-capitalize"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <template v-if="$store.getters.languageGetter === '1'">
                          عرض المزيد
                        </template>
                        <template v-else>
                          View More
                        </template>
                        <v-icon
                          :color="item.dStatus !== '1' ? 'grey' : ''"
                          right
                          class="flip-reverse"
                          :class="value ? 'reverse' : ''"
                        >
                          mdi-menu-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-if="item.dStatus === '1'"
                        @click="show = true;toCancelId = item.id"
                      >
                        <v-list-item-title>
                          <template v-if="$store.getters.languageGetter === '1'">
                            الغاء الطلب
                          </template>
                          <template v-else>
                            Cancel Order
                          </template>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              <tr style="height:20px" />
            </tbody>
          </template>
        </v-data-table>
        <div class="text-center">
          <v-pagination
            v-if="length"
            v-model="page"
            page-aria-label="Page"
            previous-aria-label="PrevPage"
            next-aria-label="NextPage"
            wrapper-aria-label="Pagination"
            current-page-aria-label="CurrentPage"
            :length="length"
            :total-visible="7"
            @input="changePagination"
          />
        </div>
      </div>
    </template>
    <v-dialog
      v-model="show"
      max-width="400"
    >
      <v-card>
        <v-card-title class="pe-2">
          <v-spacer />
          <v-btn
            icon
            @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-8 px-4 headline black--text d-flex align-center">
          <v-icon
            size="48"
            color="#f1c054"
            class="me-2"
          >
            mdi-information
          </v-icon>
          <template v-if="$store.getters.languageGetter === '1'">
            هل أنت متأكد من إلغاء هذا الطلب؟
          </template>
          <template v-else>
            Are you sure to cancel this order?
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey darken-1"
            text
            outlined
            @click="show = false"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يلغي
            </template>
            <template v-else>
              Cancel
            </template>
          </v-btn>
          <v-btn
            :loading="cancelling"
            color="#ff9a00"
            depressed
            dark
            @click="cancelOrder"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يتأكد
            </template>
            <template v-else>
              Confirm
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { statusFilter } from '@/plugins/filters';

export default {
  name: 'UserOrderList',
  components: {
  },
  filters: {
    statusFilter,
  },
  props: {
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      page: 1,
      show: false,
      loading: false,
      cancelling: false,
      toCancelId: '',
      toggleIndex: 0,
      targets: [
        {
          name: 'all',
          dStatus: '0',
        },
        {
          name: 'unpayed',
          dStatus: '1',
        },
        {
          name: 'shipped',
          dStatus: '8',
        },
        {
          name: 'canceled',
          dStatus: '2',
        },
        {
          name: 'completed',
          dStatus: '10',
        },
      ],
    };
  },
  computed: {
    ...mapState('center', ['orderList']),
    headers() {
      return [
        {
          text: this.$store.getters.languageGetter === '1' ? 'معلومات قائمة الشراء' : 'Order Information',
          align: 'start',
          sortable: false,
          value: 'item',
          class: 'text-h6 black--text grey lighten-4',
          width: 500,
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'السعر الإجمالي للبضائع' : 'Grand Total',
          value: 'amount',
          sortable: false,
          class: 'text-h6 black--text grey lighten-4',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'حالة الطلب' : 'Order Status',
          value: 'dStatus',
          class: 'text-h6 black--text grey lighten-4',
          sortable: false,
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'عرض العملية' : 'Action',
          value: 'action',
          class: 'text-h6 black--text grey lighten-4',
          sortable: false,
          width: 100,
        },
      ];
    },
    target() {
      return this.orderList[this.targets[this.toggleIndex].name].data;
    },
    length() {
      return Math.ceil((this.target.totalItem ? this.target.totalItem : 0) / 10);
    },
  },
  watch: {
    toggleIndex() {
      this.page = +this.target.p;
      this.loadPageData();
    },
  },
  created() {
    this.toggleIndex = this.active;
    this.loading = true;
    this.loadPageData();
    this.loadUnpayedOrders();
  },
  methods: {
    ...mapActions('center', ['getOrderListAsync', 'cancelOrderAsync']),
    ...mapActions('goods', ['setGoodsUnfavoriteAsync']),
    ...mapMutations('center', ['RESET_ORDER_LIST']),
    loadPageData() {
      this.getOrderListAsync({
        p: this.page, dStatus: this.targets[this.toggleIndex].dStatus, operate: '0', sortType: '2', target: this.targets[this.toggleIndex].name, timeLimit: this.target.timeLimit,
      }).then(() => {
        this.page = +this.target.p;
      }).finally(() => {
        this.loading = false;
      });
    },
    loadUnpayedOrders() {
      this.getOrderListAsync({
        p: this.orderList.unpayed.data.p, dStatus: '1', operate: '0', sortType: '2', target: 'unpayed',
      });
    },
    cancelOrder() {
      this.cancelling = true;
      this.cancelOrderAsync({ id: this.toCancelId }).then(() => {
        this.loadPageData();
      }).finally(() => {
        this.cancelling = false;
        this.show = false;
      });
    },
    changePagination() {
      this.loadPageData();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
